import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Button, FileInput, Loader } from 'oxyrion-ui/lib';
import { rem } from 'polished';
import { __ } from '../../Utils';
import { connect } from '../../Store';
import { LoaderWrapper } from '../ReusableComponents';
import ErrorMessage from '../ErrorMessage';
import API2 from '../../API2';
// import API from '../../API';

const Wrapper = styled.div``;

const ContentWrapper = styled.div`
  width: 90%;
  flex-direction: column;
  max-width: ${rem(690)};
  display: flex;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: ${rem(20)};
  ${({ theme }) => theme.media.m`
  width: 100%;
  min-width: ${rem(300)};
`};
`;
const ButtonWrapper = styled.div`
  padding: ${rem(10)};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const MainText = styled.div`
  display: flex;
  justify-content: center;
  font-size: ${rem(24)};
  font-family: 'Open sans';
  font-weight: 400;
  padding: ${rem(5)};
  text-align: center;
`;

const GreenMainText = styled(MainText)`
  color: ${({ theme }) => theme.color.primary};
`;

const SubText = styled(MainText)`
  font-weight: 200;
  font-size: ${rem(14)};
  color: black;
`;

const Label = styled.div``;

const Space = styled.div`
  width: ${rem(10)};
`;

const NoItemsWrapper = styled.div`
  padding: ${rem(10)};
`;

const SubWrapper = styled.div`
  margin-bottom: ${rem(25)};
`;

const NoItemsTitle = styled.div`
  font-weight: 800;
  margin-bottom: ${rem(10)};
  color: red;
`;

const Item = styled.div`
  margin-bottom: ${rem(2)};
`;

const acceptedMimeTypes = ['application/zip', 'text/xml'];

class OrderImport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      file: { fileValue: '', file: null, fileError: false },
      success: false,
      showConfirmImport: false,
      noEanItems: [],
      notFoundItems: [],
    };
  }

  async onSubmit(deleteActualItems = false) {
    const { file } = this.state;
    const { onSuccess } = this.props;
    this.setState({
      loading: true,
    });
    try {
      const newCart = await API2.postOrderImport({
        body: file.file,
      });

      // ak treba preniest

      this.setState({
        success: true,
        noEanItems: newCart.skippedNoEan || [],
        notFoundItems: newCart.skippedNotFound || [],
      });
      onSuccess(newCart);
    } catch (e) {
      switch (e.response.status) {
        case 404:
          this.setState({ error: __('XML súbor sa nenašiel ("/IN/*.xml")') });
          break;
        case 403:
          this.setState({ error: __('Nemáte potrebné práva.') });
          break;
        default:
          this.setState({
            error: __('Pri importe dát sa vyskytla chyba.'),
          });
      }
    }
    this.setState({
      loading: false,
      showConfirmImport: false,
    });
  }

  showConfirm() {
    if (this.props.cart.items && this.props.cart.items.length > 0) {
      this.setState({
        showConfirmImport: true,
      });
    } else {
      this.onSubmit();
    }
  }

  fileOnChange(filesInput) {
    if (filesInput.length) {
      const f = filesInput[0];
      if (!acceptedMimeTypes.includes(f.type)) {
        this.setState({ error: __('Zlý formát súboru.') });
      } else {
        const file = {
          fileValue: f.name,
          file: f,
          fileError: false,
          errors: [],
        };
        this.setState({
          file,
        });
      }
    }
  }

  removeFile() {
    this.setState({
      file: { fileValue: '', file: null, fileError: false },
    });
  }

  render() {
    const {
      error,
      file,
      success,
      loading,
      showConfirmImport,
      noEanItems,
      notFoundItems,
    } = this.state;
    const { toCart } = this.props;

    return (
      <Wrapper>
        {success ? (
          <ContentWrapper>
            <GreenMainText>
              {__('Objednávka úspešne importovaná')}
            </GreenMainText>
            <NoItemsWrapper>
              {noEanItems.length > 0 && (
                <SubWrapper>
                  <NoItemsTitle>{__('Chýbajúci EAN: ')}</NoItemsTitle>
                  {noEanItems.map(item => {
                    if (item['ord:text'] && item['ord:text'].length > 0) {
                      return <Item>{`- ${item['ord:text']}`}</Item>;
                    } else if (item.article_name) {
                      return <Item>{`- ${item.article_name}`}</Item>;
                    }
                    return '';
                  })}
                </SubWrapper>
              )}
              {notFoundItems.length > 0 && (
                <SubWrapper>
                  <NoItemsTitle>Produkty, ktoré sa nenašli:</NoItemsTitle>
                  {notFoundItems.map(item => {
                    if (item['ord:text'] && item['ord:text'].length > 0) {
                      return <Item>{`- ${item['ord:text']}`}</Item>;
                    } else if (item.article_name) {
                      return <Item>{`- ${item.article_name}`}</Item>;
                    }

                    return '';
                  })}
                </SubWrapper>
              )}
            </NoItemsWrapper>
            <ButtonWrapper>
              <Button onClick={() => toCart()} primary>
                {__('Prejsť k objednávke')}
              </Button>
            </ButtonWrapper>
          </ContentWrapper>
        ) : (
          <ContentWrapper>
            <ErrorMessage display={error} text={error} />
            {loading ? (
              <LoaderWrapper style={{ width: '100%' }}>
                <Loader size="xl" />
              </LoaderWrapper>
            ) : (
              <React.Fragment>
                {!showConfirmImport ? (
                  <React.Fragment>
                    <Label>{__('Vyberte súbor')}</Label>
                    <FileInput
                      style={{
                        width: '90%',
                      }}
                      item={file.fileValue}
                      onChange={e => this.fileOnChange(e.target.files)}
                      onRemoveFile={() => this.removeFile()}
                    />
                    <ButtonWrapper>
                      <Button
                        disabled={!file.file}
                        onClick={() => this.onSubmit()}
                        primary
                      >
                        {__('Importovať')}
                      </Button>
                    </ButtonWrapper>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <MainText>
                      {__('Prajete si prepísať aktuálny obsah košíka?')}
                    </MainText>
                    <SubText>
                      {__(
                        'Áno - prepíše aktuálny košík. Nie - doplní aktuálny košík o import',
                      )}
                    </SubText>
                    <ButtonWrapper>
                      <Button danger onClick={() => this.onSubmit(true)}>
                        {__('Áno')}
                      </Button>
                      <Space />
                      <Button primary onClick={() => this.onSubmit(false)}>
                        {__('Nie')}
                      </Button>
                    </ButtonWrapper>
                  </React.Fragment>
                )}
              </React.Fragment>
            )}
          </ContentWrapper>
        )}
      </Wrapper>
    );
  }
}

OrderImport.propTypes = {
  onSuccess: PropTypes.func,
  toCart: PropTypes.func,
  cart: PropTypes.shape({}),
};

OrderImport.defaultProps = {
  onSuccess: () => {},
  toCart: () => {},
  cart: {},
};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(OrderImport);



// WEBPACK FOOTER //
// ./src/Components/OrderImport/index.jsx